import type { FaireProductEntity } from "../../entity_types/product";

export const atc_goes_well_6: FaireProductEntity = {
  token: "atc_goes_well_6",
  type: "product",
  name: "Reusable Silicone Bag",
  brandName: "Stasher",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/f3b4f3bae3a151722c86f2d3f1e6904a5de22eaaec8d5ad3e556192688d73892.jpeg",
  priceDollars: 10,
  msrpDollars: 20,
  description: "Recommended accessory for ATC flow.",
  tags: ["goes-well-with", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
